import { useMemo, useState, useCallback, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import moment from 'moment';
import classNames from 'classnames';
import { textFormatter } from 'utils';
import Images from 'assets/Images';
import { Checkbox, ToggleSwitch } from '..';
import './style.scss';

export default function Table(props) {
	const { tableHeader, tableData, tableWidth, handleSort, infiniteScroll, handleScroll, scrollToTop, checkboxWidth, hideHeaderCheckbox, onCheckboxClick, checkedItem, handleToggle, checkboxDisabled } = props;
	const [displayArray, setDisplayArray] = useState(false);
	const arrayListRef = useRef();
	const observer = useRef();
	const tableBody = useRef();

	const setDateFormat = (date, format) => {
		return date ? moment(date).format(format || 'DD-MM-YYYY') : '-';
	};

	// outside click handle function
	const handleClickOutside = useCallback(
		event => {
			if (arrayListRef?.current && !arrayListRef?.current?.contains(event?.target)) {
				setDisplayArray(false);
			}
		},
		[displayArray, setDisplayArray]
	);

	// outside click handler
	useEffect(() => {
		document.addEventListener('click', handleClickOutside, true);
		return () => {
			document.removeEventListener('click', handleClickOutside, true);
		};
	}, [displayArray, handleClickOutside]);

	const arrayList = (arr, dateFormat) => {
		const list = arr?.map((el, i) => (
			<li key={i} className='space-around list-container__item'>
				<div className='list-container__subsection'>
					<p>Amount</p>
					<span>
						<img src={Images?.wallet} alt='Wallet' />
						{el?.pp_amount}
					</span>
				</div>
				<div className='list-container__subsection'>
					<p>Pay on</p>
					<span>
						<img src={Images?.calandar} alt='calandar' />
						{el?.pp_date ? moment(el?.pp_date).format(dateFormat || 'DD-MM-YYYY') : '-'}
					</span>
				</div>
			</li>
		));

		return (
			<div className='list-container scroll-bar' ref={arrayListRef}>
				<h5>Payment Schedule Details</h5>
				<ul>{list}</ul>
			</div>
		);
	};

	const arrayItem = (el, i, dateFormat) => {
		return (
			<>
				<div className='flex-start' onClick={() => setDisplayArray(i)}>
					<span className='list-container__field'>{el?.at()?.pp_amount}</span>
					<span className='list-container__field align-center'>
						<img src={Images?.calandarV2} alt='calandar' /> {el?.at()?.pp_date ? moment(el?.at()?.pp_date)?.format(dateFormat || 'DD-MM-YYYY') : '-'}
						<img src={Images?.eye} alt='view' />
						{displayArray === i && arrayList(el, dateFormat)}
					</span>
				</div>
			</>
		);
	};

	const lastElementRef = useCallback(
		node => {
			observer?.current && observer?.current?.disconnect();
			observer.current = new IntersectionObserver(entries => {
				if (entries[0].isIntersecting) {
					handleScroll(20);
					scrollToTop && tableBody.current.scrollIntoView();
				}
			});
			node && observer?.current?.observe(node);
		},
		[infiniteScroll, scrollToTop]
	);

	const handleItemCheckbox = (e, i) => {
		const value = e?.target?.checked ? i : null;
		onCheckboxClick(value);
	};

	const data = useMemo(() => {
		return map(tableData, (el, i) => (
			<tr ref={lastElementRef} key={i}>
				{checkboxWidth && (
					<td>
						<Checkbox disabled={checkboxDisabled?.allow ? !(el[checkboxDisabled?.key] === 'true') : false} last checked={checkedItem === i} onClick={e => handleItemCheckbox(e, i)} />
					</td>
				)}
				{map(tableHeader, (elm, j) => (
					<td key={j}>
						{elm?.data_type === 'date' ? setDateFormat(el[elm?.field_key], elm?.dateFormat) : elm?.data_type === 'array' ? arrayItem(el[elm?.field_key], i, elm?.dateFormat) : elm?.toggle ? <ToggleSwitch checked={el[elm?.field_key] === 'true'} onChange={e => handleToggle(e, el)} /> : elm?.c_id ? `${textFormatter(el[elm?.field_key]?.split('_')?.at())}_${localStorage.getItem('c_id')}` : textFormatter(el[elm?.field_key]) || '-'}
					</td>
				))}
			</tr>
		));
	}, [tableHeader, tableData, displayArray, checkedItem]);

	const headers = useMemo(
		() =>
			map(tableHeader, (el, i) => (
				<th key={i} style={{ width: `${el?.columnWidth}px`, maxWidth: `${el?.columnWidth}px` }}>
					{el?.label}
					{el?.sort && (
						<div className='sort-arrow'>
							<span onClick={() => handleSort({ id: el?.field_key, value: 1 })} className={classNames({ 'sort-arrow__up': true })}></span>
							<span onClick={() => handleSort({ id: el?.field_key, value: -1 })} className={classNames({ 'sort-arrow__down': true })}></span>
						</div>
					)}
				</th>
			)),
		[tableHeader]
	);

	return (
		<>
			<div className='table-row hr-scroll scroll-bar'>
				<table className='table-row__table' style={{ width: tableWidth }}>
					<thead>
						<tr>
							{checkboxWidth && <th style={{ width: checkboxWidth || '40px' }}>{!hideHeaderCheckbox && <Checkbox last />}</th>}
							{headers}
						</tr>
					</thead>
					<tbody ref={tableBody}>{data}</tbody>
				</table>
			</div>
		</>
	);
}

Table.propTypes = {
	tableHeader: PropTypes.array,
	tableData: PropTypes.array,
	tableWidth: PropTypes.any
};

Table.defaultProps = {
	tableHeader: [],
	tableData: [],
	tableWidth: '1200px'
};
